import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ShopsList from "./pages/ShopsList";
import ShopDetails from "./pages/ShopDetails";
import RegisterShop from "./pages/RegisterShop";
import RegisterAdmin from "./pages/RegisterAdmin";
import PaymentHistory from "./pages/PaymentHistory";
import SubscriptionCredits from "./pages/SubscriptionCredits";
import ScheduledJobs from "./pages/ScheduledJobs";
import MakeModelList from "./pages/MakeModelList";
import RegularServicesList from "./pages/RegularServicesList";
import MaintenanceServicesList from "./pages/MaintenanceServicesList";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
          <Routes>
            {/* Public route */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/shops" replace />} />
              <Route path="shops" element={<ShopsList />} />
              <Route path="subscriptions" element={<SubscriptionCredits />} />
              <Route path="scheduled-jobs" element={<ScheduledJobs />} />
              <Route
                path="shops/new"
                element={
                  <ProtectedRoute requireEdit>
                    <RegisterShop />
                  </ProtectedRoute>
                }
              />
              <Route path="shops/:id" element={<ShopDetails />} />
              <Route path="shops/:id/payments" element={<PaymentHistory />} />
              <Route
                path="shops/:id/admin/new"
                element={
                  <ProtectedRoute requireEdit>
                    <RegisterAdmin />
                  </ProtectedRoute>
                }
              />
              {/* Master Lists */}
              <Route path="master-lists/make-model" element={<MakeModelList />} />
              <Route path="master-lists/regular-services" element={<RegularServicesList />} />
              <Route path="master-lists/maintenance-services" element={<MaintenanceServicesList />} />
            </Route>

            {/* Catch all - redirect to shops */}
            <Route path="*" element={<Navigate to="/shops" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
